// api.js — Place this file in your stock-tracker/src/ folder
// This handles all communication between your React frontend and Express backend

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// ─── Token helpers ───
const getToken = () => localStorage.getItem('auth_token');
const setToken = (token) => localStorage.setItem('auth_token', token);
const clearToken = () => localStorage.removeItem('auth_token');

const headers = () => {
  const h = { 'Content-Type': 'application/json' };
  const token = getToken();
  if (token) h['Authorization'] = `Bearer ${token}`;
  return h;
};

// ─── Generic fetch wrapper ───
const request = async (path, options = {}) => {
  const res = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: headers(),
  });
  if (res.status === 401) {
    clearToken();
    throw new Error('Session expired. Please log in again.');
  }
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
};

// ─── Auth ───
export const login = async (email, password) => {
  const data = await request('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
  setToken(data.token);
  return data;
};

export const logout = () => {
  clearToken();
};

export const isAuthenticated = () => !!getToken();

// ─── Items (Inventory) ───
export const fetchItems = () => request('/api/items');

export const createItem = (item) =>
  request('/api/items', {
    method: 'POST',
    body: JSON.stringify(item),
  });

export const updateItem = (id, updates) =>
  request(`/api/items/${id}`, {
    method: 'PUT',
    body: JSON.stringify(updates),
  });

export const deleteItem = (id) =>
  request(`/api/items/${id}`, {
    method: 'DELETE',
  });

export const moveStock = (itemId, type, quantity, person, purpose) =>
  request('/api/items/move', {
    method: 'POST',
    body: JSON.stringify({ itemId, type, quantity, person, purpose }),
  });

// ─── Transactions / Movements ───
export const fetchTransactions = () => request('/api/transactions');

// ─── Email alerts ───
export const sendLowStockAlert = (category, items) =>
  request('/api/email/low-stock', {
    method: 'POST',
    body: JSON.stringify({ category, items }),
  });